import { TooltipRenderProps } from 'react-joyride'

export const ReleaseTooltip = ({ tooltipProps, primaryProps, backProps, skipProps, isLastStep, index, size, step }: TooltipRenderProps) => (
    <div {...tooltipProps} className="relative w-72 max-w-[calc(100vw-2rem)] rounded-2xl bg-accent p-5 text-accent-foreground shadow-overlay">
        <p className="pr-5 text-xs font-medium text-accent-foreground/75">Try new feature{size > 1 ? ` · ${index + 1}/${size}` : ''}</p>
        <h2 className="mt-2 pr-2 text-base font-semibold leading-6">{step.title}</h2>
        <div className="mt-2 text-sm leading-6 text-accent-foreground/90">{step.content}</div>
        <div className="mt-5 flex items-center justify-between gap-3">
            <button
                {...skipProps}
                aria-label="Discard"
                title="Discard"
                type="button"
                className="text-xs text-accent-foreground/80 underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-foreground"
            >
                Discard
            </button>
            <div className="flex items-center gap-3">
                {index > 0 && (
                    <button
                        {...backProps}
                        type="button"
                        className="text-sm text-accent-foreground hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-foreground"
                    >
                        Back
                    </button>
                )}
                <button
                    {...primaryProps}
                    aria-label={isLastStep ? 'Got it' : 'Next'}
                    title={isLastStep ? 'Got it' : 'Next'}
                    type="button"
                    className="inline-flex h-8 items-center justify-center rounded-3xl bg-accent-foreground px-4 text-sm font-medium text-accent shadow-field transition-colors hover:bg-accent-foreground/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-foreground focus-visible:ring-offset-2 focus-visible:ring-offset-accent"
                >
                    {isLastStep ? 'Got it' : 'Next'}
                </button>
            </div>
        </div>
    </div>
)
